import { TabbedItemPage } from './TabbedItemPage';

export const EmployeeProcessesPage = () => <TabbedItemPage itemPath="/workers/employee-processes" />;
